import { useNavigate, useParams, Routes, Route, Navigate } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { UsersTab } from "@/components/settings/UsersTab";
import { EmployeesTeamsTab } from "@/components/settings/EmployeesTeamsTab";
import { MappingsTab } from "@/components/settings/MappingsTab";
import { BrandingGeneralTab } from "@/components/settings/BrandingGeneralTab";
import { AuditTab } from "@/components/settings/AuditTab";
import { WebhooksTab } from "@/components/settings/WebhooksTab";
import { SchedulesTab } from "@/components/settings/SchedulesTab";
import { SystemHealthTab } from "@/components/settings/SystemHealthTab";
import { BackupsTab } from "@/components/settings/BackupsTab";
import { ConnectorsTab } from "@/components/settings/ConnectorsTab";

const TABS = [
  { id: "users", label: "Users & Access" },
  { id: "employees", label: "Employees & Teams" },
  { id: "connectors", label: "Connectors & Identities" },
  { id: "mappings", label: "Field Mappings & Build Status" },
  { id: "general", label: "Branding & General" },
  { id: "webhooks", label: "EZLynx Webhooks" },
  { id: "schedules", label: "Feed Schedules & Watchdog" },
  { id: "system", label: "System Health" },
  { id: "backups", label: "Backups & Retention" },
  { id: "audit", label: "Audit Log" },
];

function SettingsLayout() {
  const { tab = "users" } = useParams();
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader title="Settings & Mappings" description="Users and roles, employee roster and aliases, teams, EZLynx field mappings, branding, reporting assumptions and the audit log." />
      <Tabs value={tab} onValueChange={(v) => navigate(`/settings/${v}`)}>
        <TabsList className="flex flex-wrap h-auto justify-start gap-1 rounded-lg border border-slate-200 bg-slate-100/60 p-1">{TABS.map((t) => <TabsTrigger key={t.id} value={t.id} data-testid={`settings-tab-${t.id}`} className="rounded-md px-3 py-1.5 text-xs font-medium text-slate-600 transition-all data-[state=active]:bg-white data-[state=active]:font-semibold data-[state=active]:text-[#101C47] data-[state=active]:shadow-sm">{t.label}</TabsTrigger>)}</TabsList>
      </Tabs>
      <div className="mt-6">
        {tab === "users" && <UsersTab />}
        {tab === "employees" && <EmployeesTeamsTab />}
        {tab === "connectors" && <ConnectorsTab />}
        {tab === "mappings" && <MappingsTab />}
        {tab === "general" && <BrandingGeneralTab />}
        {tab === "webhooks" && <WebhooksTab />}
        {tab === "schedules" && <SchedulesTab />}
        {tab === "system" && <SystemHealthTab />}
        {tab === "backups" && <BackupsTab />}
        {tab === "audit" && <AuditTab />}
      </div>
    </div>
  );
}

export default function SettingsPage() {
  return (
    <Routes>
      <Route index element={<Navigate to="/settings/users" replace />} />
      <Route path=":tab" element={<SettingsLayout />} />
    </Routes>
  );
}
